import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;

    const check = async () => {
      const { data } = await supabase.auth.getSession();
      if (cancelled) return;

      if (data.session) {
        navigate("/", { replace: true });
        return;
      }

      attempts += 1;
      if (attempts >= 10) {
        setError("Session introuvable. Réessayez la connexion.");
        return;
      }
      setTimeout(check, 300);
    };

    check();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-redi-dark flex items-center justify-center px-6">
      {error ? (
        <div className="max-w-md text-center">
          <p className="text-redi-error text-base mb-4">{error}</p>
          <button
            onClick={() => navigate("/login", { replace: true })}
            className="px-4 py-2 rounded-lg bg-redi-primary text-white text-sm font-semibold"
          >
            Retour à la connexion
          </button>
        </div>
      ) : (
        <div className="text-redi-primary text-lg animate-pulse">...</div>
      )}
    </div>
  );
}
